"use strict";

var _slicedToArray = require("/tmp/build_2b6a6b3d/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/tmp/build_2b6a6b3d/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/tmp/build_2b6a6b3d/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_2b6a6b3d/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Lexicon = void 0;

var isString_1 = __importDefault(require("lodash/isString"));

var isUndefined_1 = __importDefault(require("lodash/isUndefined"));

var isNil_1 = __importDefault(require("lodash/isNil"));

var cloneDeepWith_1 = __importDefault(require("lodash/cloneDeepWith"));

var has_1 = __importDefault(require("lodash/has"));

var compact_1 = __importDefault(require("lodash/compact"));

var concat_1 = __importDefault(require("lodash/concat"));

var map_1 = __importDefault(require("lodash/map"));

var col = __importStar(require("./collection"));

var util_1 = require("./util");

var DEFAULT_LOCALE_CODE = 'en';

function isLocaleCode(locale) {
  return isString_1.default(locale) && locale.length < 10;
} //
//      Lexicon — A tree-like container for holding content. Lexicons can hold other Lexicons.
//


var Lexicon = /*#__PURE__*/function () {
  function Lexicon(contentByLocale, localeCode, filename) {
    var subset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    _classCallCheck(this, Lexicon);

    if (!has_1.default(contentByLocale, DEFAULT_LOCALE_CODE)) {
      throw new Error("'contentByLocale' must contain 'en: {...}' locale");
    }

    this.currentLocaleCode = localeCode;
    this._filename = filename;
    this._contentByLocale = contentByLocale;
    this._subsetRoot = col.keyPathAsArray(subset);
  } //
  //    Methods for use by Lexicon clients
  //

  /* Return a new Lexicon with same contents, but different default language code */


  _createClass(Lexicon, [{
    key: "locale",
    value: function locale(localeCode) {
      if (!isLocaleCode(localeCode)) throw new Error("'localeCode' should be e.g. 'en', not: ".concat(localeCode));
      if (!col.has(this._contentByLocale, localeCode)) return null;
      return new Lexicon(this._contentByLocale, localeCode, this._filename, this._subsetRoot);
    }
    /*
       Return a value from the Lexicon, in the current locale.
       If you pass 'templateSubsitutions', and the value is a string, then they they are inserted into your string,
          e.g. "hello #{name}" -> "hello Winston"
    */

  }, {
    key: "get",
    value: function get(keyPath, templateSubstitutions) {
      if (isNil_1.default(keyPath)) throw new Error("'keyPath' is null/undefined");
      var info = this.find(this.currentLocaleCode, keyPath);

      if (isNil_1.default(info)) {
        // could not find it--try English
        info = this.find(DEFAULT_LOCALE_CODE, keyPath);

        if (isNil_1.default(info)) {
          // still couldn't find it--return a clue of the problem
          return "[no content for \"".concat(col.keyPathAsString(this.fullKey(this.currentLocaleCode, keyPath)), "\"]");
        }
      }

      var val = info.value;

      if (isString_1.default(val) && !isUndefined_1.default(templateSubstitutions)) {
        val = util_1.evaluateTemplate(val, templateSubstitutions);
      }

      return val;
    }
    /*
     * Gets value, but if the value is not found, return 'undefined'. I.e. don't roll over to default
     * dictionary, or produce informative default value.
     */

  }, {
    key: "getExact",
    value: function getExact(keyPath) {
      if (isNil_1.default(keyPath)) throw new Error("'keyPath' is null/undefined");
      var info = this.find(this.currentLocaleCode, keyPath);

      if (isNil_1.default(info)) {
        return undefined; // could not find value
      }

      return info.value;
    }
    /* Return a new Lexicon, with the "root" starting at a different place.
       E.g.
         a = Lexicon({greeting: "hi", secondLevel: {title: "Mister"}})
         a.subset('secondLevel') // --> Lexicon({title: "Mister"})
    */

  }, {
    key: "subset",
    value: function subset(keyPath) {
      var rootPathExcludingLocale = this.fullKey(null, keyPath);
      return new Lexicon(this._contentByLocale, this.currentLocaleCode, this._filename, rootPathExcludingLocale);
    }
    /* Determine the complete "key path" to retrieve our value */

  }, {
    key: "fullKey",
    value: function fullKey(locale, keyPath) {
      var parts = compact_1.default([locale, col.keyPathAsString(this._subsetRoot), col.keyPathAsString(keyPath)]);
      return parts.join('.');
    }
    /* Find some content and return info about that node */

  }, {
    key: "find",
    value: function find(locale, keyPath) {
      if (!isLocaleCode(locale)) throw new Error("'locale' should be LocaleCode, e.g. 'en', not: ".concat(locale));
      if (isNil_1.default(keyPath)) throw new Error("'keyPath' is null/undefined");
      return recursiveFind(this, col.keyPathAsArray(keyPath), this, [], []);

      function recursiveFind(node, keyPath, lexicon, rootPrefix, localPrefix) {
        //       console.log('!!! recursiveFind() rootPrefix=', rootPrefix, 'localPrefix=', localPrefix, 'keyPath=', keyPath, 'node=', node)
        if (isUndefined_1.default(node)) {
          return null; // could not find the node
        }

        if (isNil_1.default(keyPath)) throw new Error("'keyPath' is null/undefined");

        if (keyPath.length == 0 && !(node instanceof Lexicon)) {
          var result = {
            lexicon: lexicon,
            locale: locale,
            keyPath: localPrefix,
            updatePath: rootPrefix,
            value: node
          };
          return result; // Found it!
        }

        ;
        var nextNode = undefined;

        if (node instanceof Lexicon) {
          lexicon = node;
          localPrefix = [];
          rootPrefix = rootPrefix.concat(['_contentByLocale', locale]);
          keyPath = concat_1.default(col.keyPathAsArray(lexicon._subsetRoot), keyPath);
          nextNode = col.get(lexicon._contentByLocale, [locale]);
        } else {
          var firstKey = keyPath[0];
          keyPath = keyPath.slice(1);
          rootPrefix = rootPrefix.concat([firstKey]); // use concat to not modify old value

          localPrefix = localPrefix.concat([firstKey]);
          nextNode = col.get(node, firstKey);
        }

        return recursiveFind(nextNode, keyPath, lexicon, rootPrefix, localPrefix);
      }

      ;
    } //
    //    Methods for use by Lexicon Editor
    //

    /*
       Returns the filename and KeyPath of the item in question.
       The returned keyPath might be different from the input because you're looking
       at a Lexicon subset, with some keys hidden.
     */

  }, {
    key: "source",
    value: function source(keyPath) {
      var info = this.find(this.currentLocaleCode, keyPath);
      if (info == null) throw new Error("Lexicon: Could not find keyPath: '".concat(keyPath, "' in file: '").concat(this.filename(), "'"));
      return {
        filename: info.lexicon.filename(),
        localPath: [info.locale].concat(info.keyPath),
        updatePath: info.updatePath
      };
    }
    /* Return language codes for available locales */

  }, {
    key: "locales",
    value: function locales() {
      return col.keys(this._contentByLocale);
    }
    /* Used by LexiconEditor */

  }, {
    key: "filename",
    value: function filename() {
      return this._filename;
    }
    /* Return list of dotted keys, e.g. ['mycomponent.title', 'mycomponent.page1.intro'] */

  }, {
    key: "keys",
    value: function keys() {
      var info = this.find(this.currentLocaleCode, []);
      if (isNil_1.default(info)) return [];
      var startingNode = info.value;
      var flatKeys = [];
      recurse(startingNode, '');
      return flatKeys;

      function recurse(c, prefix) {
        var _iterator = _createForOfIteratorHelper(col.entries(c)),
            _step;

        try {
          var _loop = function _loop() {
            var _step$value = _slicedToArray(_step.value, 2),
                key = _step$value[0],
                node = _step$value[1];

            if (node instanceof Lexicon) {
              var subKeys = node.keys();
              var prefixedKeys = map_1.default(subKeys, function (keyPath) {
                return "".concat(prefix).concat(key, ".").concat(keyPath);
              });
              flatKeys = flatKeys.concat(prefixedKeys);
            } else if (col.isCollection(node)) {
              recurse(node, "".concat(prefix).concat(key, "."));
            } else {
              flatKeys.push("".concat(prefix).concat(key));
            }
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
    /*
     * Change value in a lexicon.
     * Note that updatePath is interepreted from the root of this Lexicon, and ignores current
     * locale and subset settings
     */

  }, {
    key: "update",
    value: function update(updatePath, newValue) {
      if (!col.has(this, updatePath)) return false; // node does not exist

      col.set(this, updatePath, newValue);
      return true; // success
    }
    /* Used by LexiconEditor */

  }, {
    key: "cloneDeep",
    value: function cloneDeep() {
      function customizer(value) {
        if (value instanceof Lexicon) {
          return value.cloneDeep();
        }
      }

      return new Lexicon(cloneDeepWith_1.default(this._contentByLocale, customizer), this.currentLocaleCode, this._filename, this._subsetRoot);
    }
  }, {
    key: "clone",
    value: function clone() {
      console.warn('Lexicon.ts: clone() is deprecated. Use cloneDeep() instead.');
      return this.cloneDeep();
    }
  }]);

  return Lexicon;
}();

exports.Lexicon = Lexicon;